import React, { useState } from "react";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbarcopy";
import {
  BankFormat,
  BankSubmitFormat,
  EmployeeDetails,
  IncrementsDetails,
  PrintFormat,
  TaxCalculationTable,
  PayRollTable,
  // Arreartable,
  // Incentivetable,
  // DynamicNaturetable,
} from "./PayrollTables";
import { PaymentDashboard } from './PayrollComponent';
import { useLocation } from "react-router-dom";


const PayrollManagement = () => {
  const location = useLocation();
  const togglepayroll = location.state !== null ? location.state?.togglepayroll : 2;
  const [toggleState, setToggleState] = useState(togglepayroll);
  const emp_code = sessionStorage.getItem("emp_code")
  const getSelectedTitle = () => {
    switch (toggleState) {
      case 1:
        return "PayRoll Dashboard";
      case 2:
        return "Pay Run";
      case 3:
        return "Monthly Salary";
      case 4:
        return "Employee Details";
      case 5:
        return "Bank Format";
      case 7:
        return "Bank Format";
      case 8:
        return "Increment Details";
      // case 11:
      //   return "Arrear";
      // case 12:
      //   return "Incentive";
      // case 13:
      //   return "Dynamic Nature";

      default:
        return "Payroll Management";
    }
  };

  return (
    <>
      <div>
        <div>
          <Dashboardnavbarcopy name={getSelectedTitle()} url="Pay Roll" />
          <div className="bloc-tabss  wfm-margin">
            {/* <button
              className={
                toggleState === 1
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(1)}
            >
              PayRoll Dashboard
            </button> */}
            <button
              className={
                toggleState === 2
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(2)}
            >
              PayRoll Management
            </button>
            <button
              className={
                toggleState === 9
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(9)}
            >
              TDS Calculation
            </button>

            <button
              className={
                toggleState === 4
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(4)}
            >
              Employee Salary Records
            </button>
            {/* <button
              className={
                toggleState === 5
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(5)}
            >
              Bank Format
            </button> */}
            {/* <button
             */}
            {/* <button
              className={
                toggleState === 7
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(7)}
            >
              Bank Submition Format
            </button> */}
            <button
              className={
                toggleState === 8
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(8)}
            >
              Increment Data
            </button>
            {/* <button
              className={
                toggleState === 11
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(11)}
              >
              Arrear
            </button>
            <button
              className={
                toggleState === 12
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(12)}
              >
              Incentive
            </button>
            <button
              className={
                toggleState === 13
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(13)}
               >
              Dynamic Nature
            </button> */}
            {/* <button
              className={
                toggleState === 11
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
              }
              onClick={() => setToggleState(11)}
            >
              New Upcoming PayRoll
            </button> */}
          </div>
        </div>

        <div className="content-tabs">
          {toggleState === 1 ? <PaymentDashboard /> : null}
          {/* {toggleState === 2 ? <PayRun /> : null} */}
          {toggleState === 2 ? <PayRollTable /> : null}
          {toggleState === 4 ? <EmployeeDetails /> : null}
          {toggleState === 5 ? <BankFormat /> : null}
          {toggleState === 6 ? <PrintFormat /> : null}
          {toggleState === 7 ? <BankSubmitFormat /> : null}
          {toggleState === 8 ? <IncrementsDetails /> : null}
          {toggleState === 9 ? <TaxCalculationTable /> : null}
          {/* {toggleState === 11 ? <Arreartable /> : null} */}
          {/* {toggleState === 12 ? <Incentivetable emp_code={emp_code} /> : null} */}
          {/* {toggleState === 13 ? <DynamicNaturetable /> : null} */}
        </div>
      </div>
    </>
  );
};

export default PayrollManagement;
